import React, { useContext } from "react";
import SavedProductContext from "../SavedProductsContext";

import { Box, Table, Thead, Tr, Td, Th, Tbody } from "@chakra-ui/react";

export const SelectedProductsTable = () => {
  const [products, , productsQty] = useContext(SavedProductContext);

  return (
    <Box>
      <Table variant="simple">
        <Thead>
          <Tr>
            <Th>Nombre</Th>
            <Th>Cantidad</Th>
            <Th>Precio Unitario</Th>
            <Th>Precio Total</Th>
          </Tr>
        </Thead>
        <Tbody>
          {products &&
            Object.keys(products).map((productId) => (
              <Tr key={productId}>
                <Td>{`${products[productId].description}`}</Td>
                <Td>{`${productsQty[productId]}`}</Td>
                <Td>{`$${products[productId].salePrice}`}</Td>
                <Td>
                  {`$${products[productId].salePrice * productsQty[productId]}`}
                </Td>
              </Tr>
            ))}
        </Tbody>
      </Table>
    </Box>
  );
};
